
const ticketStatuses = {
    TO_BE_DEVELOPED: "TO_BE_DEVELOPED",
    CLOSE: "CLOSE"
}

export default ticketStatuses